import { HttpInterface } from "shared";

export const Api = new HttpInterface({
	withCredentials: true,
});
